import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pb-32 pt-16 w-[90%] mx-auto" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-5 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, " Set Password ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-7" }, "To setup your password, type in your password in the provided fields below.", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-5 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, " Forgot Password ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-center mb-7" }, "To change your password, type in your new password in the provided fields below.", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = { class: "mb-5" }
const _hoisted_12 = { class: "mb-8" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-400" }, [
    /*#__PURE__*/_createTextVNode("Dont have an account yet? "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/signup",
      class: "font-bold text-primary-500"
    }, "Sign up now")
  ])
], -1)

import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import GeneralModal from '@/components/GeneralModal.vue';

import AuthService from '@/classes/AuthService';
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const loader    = ref(false)
const showError = ref(false)
const errorMsg  = ref()
const errors    = ref([])
const show      = ref(false);
const setPassword = ref(false);
const router    = useRouter();
const route    = useRoute();

const form = ref({
    token: '',
    email: '',
    password: '',
    password_confirmation: '',
})

const fetchParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries());

    form.value.token = params.token ?? null
    form.value.email = params.email ?? null
}

const submit = async () => {
    try {
        loader.value = true
        const response = await AuthService.changePassword(form.value)
        loader.value = false
        show.value = true

        setTimeout(() => {
            window.location.replace('/login');
        }, 1500);

    }catch(error) {
        loader.value = false
        loader.value = false;
        showError.value = true;
        errorMsg.value = error.response.data.message
        errors.value = error.response.data.errors
    }

}

onMounted(() => {
    fetchParams()

    if('setPassword' in route.query){
        setPassword.value = true
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (setPassword.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)),
        _createElementVNode("form", {
          class: "w-full lg:w-[350px] mx-auto",
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(PasswordInput, {
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.password) = $event)),
              id: "new-password",
              placeholder: "New Password",
              helper: "",
              error: errors.value.password ? errors.value.password[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(PasswordInput, {
              modelValue: form.value.password_confirmation,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password_confirmation) = $event)),
              id: "confirm-password",
              placeholder: "Confirm New Password"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(ButtonComponent, {
              disabled: loader.value,
              text: setPassword.value ? 'Set Password' : 'Change Password',
              type: 'submit',
              onClick: _cache[2] || (_cache[2] = ($event: any) => (submit()))
            }, null, 8, ["disabled", "text"])
          ])
        ], 40, _hoisted_10),
        _hoisted_14
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(GeneralModal, {
        width: "w-[416px]",
        title: "Password successfully changed!",
        content: "You may now login to your account.",
        "action-text": "Login",
        show: show.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (show.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => {_unref(router).push('/login'); show.value = false})
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }))
}
}

})